import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuthContext';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Registracija from './pages/Registracija';
import Dashboard from './pages/Dashboard';
import './index.css';

function PrivatnaRuta({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/prijava" replace />;
}

function PublicnaRuta({ children }) {
  const { currentUser } = useAuth();
  return !currentUser ? children : <Navigate to="/" replace />;
}

function AppRoutes() {
  const { currentUser } = useAuth();
  return (
    <div className="app-shell">
      {currentUser && <Navbar />}
      <Routes>
        <Route path="/prijava" element={
          <PublicnaRuta><Login /></PublicnaRuta>
        } />
        <Route path="/registracija" element={
          <PublicnaRuta><Registracija /></PublicnaRuta>
        } />
        <Route path="/" element={
          <PrivatnaRuta><Dashboard /></PrivatnaRuta>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
